import { render, staticRenderFns } from "./BtnIntegrarContrato.vue?vue&type=template&id=86290906&"
import script from "./BtnIntegrarContrato.vue?vue&type=script&lang=js&"
export * from "./BtnIntegrarContrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports